module.exports = __webpack_public_path__ + "media/customizations/woodlandshills/logo-c3d45c17ac2c7a1310f1f48a3f281d42.png";